import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useImportPage = ({ type }) => {
  const [loading, setLoading] = useState(true)
  const [rows, setRows] = useState([])

  const fetchData = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await RequestService.getImports({ type })
      setRows(data || [])
    } catch (e) {
      console.log('useImportPage', e)
    }

    setLoading(false)
  })

  useEffect(() => {
    fetchData()
  }, [])

  return {
    loading,
    rows,
  }
}

export default useImportPage
